import { NgModule } from "@angular/core";

import { MedHostDirective } from "./med-host.directive";
import { MedPopupDirective } from "./med-popup.directive";
import { MedTooltipDirective } from "./med-tooltip.directive";
import { MedTemplateDirective } from "./med-template.directive";
import { ClickOutsideDirective } from "./click-outside.directive";
import { MedNumberPatternDirective } from "./med-format-number.directive";
import { MedStaticContentDirective } from "./med-static-content.directive";
import { MedStickyBottomContentDirective } from "./med-sticky-bottom-content.directive";

@NgModule({
  declarations: [
    MedHostDirective,
    MedPopupDirective,
    MedTooltipDirective,
    MedTemplateDirective,
    ClickOutsideDirective,
    MedNumberPatternDirective,
    MedStaticContentDirective,
    MedStickyBottomContentDirective,
  ],
  exports: [
    MedHostDirective,
    MedPopupDirective,
    MedTooltipDirective,
    MedTemplateDirective,
    ClickOutsideDirective,
    MedNumberPatternDirective,
    MedStaticContentDirective,
    MedStickyBottomContentDirective,
  ],
})
export class MedDirectiveSharedModule { }
